var Graphics = function() {

	this.init = function() {

		this.graphics();

	}

	this.graphics = function(){

		google.charts.load('current', {'packages':['corechart']});
		google.charts.setOnLoadCallback(drawChart);

		function drawChart() {

			var GraphicValue = {};
			var GraphicValueArray = [];

			$(".graphicValue").each(function() {

				GraphicValue = {
					"Name": $(this).data("name"),
					"Color": $(this).data("color"),
					"Value": $(this).data("value")
				};

				GraphicValueArray.push(GraphicValue);
			});

			var DataTableArray = [
				['Task', 'Hours per Day']
			];

			var OptionsColorsArray = [];

			for(var i = 0; i< GraphicValueArray.length; i++) {
				DataTableArray.push([GraphicValueArray[i].Name, GraphicValueArray[i].Value]);
				OptionsColorsArray.push(GraphicValueArray[i].Color);
			}

			var data = google.visualization.arrayToDataTable(DataTableArray);

			var options = {
				title: '',
				ignoreBounds: true,
				legend: {position: 'left', textStyle:{fontSize: 20, fontName: 'Gotham Narrow Book', color: '#5c6066'}},
				chartArea: {
		      right: 130,   // set this to adjust the legend width
		      left: 60,     // set this eventually, to adjust the left margin
		   },
				colors: OptionsColorsArray,
				fontName: 'Gotham Narrow SSm Light',
				fontSize: 23
			};

			var chart = new google.visualization.PieChart(document.getElementById('piechart'));

			chart.draw(data, options);
		}

	}

	return this.init();

}
